
import React from 'react';
import { ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface FinalCTAProps {
  isProcessing: string | null;
  onSelectPlan: (plan: 'monthly' | 'annual' | 'lifetime') => void;
}

const FinalCTA = ({ isProcessing, onSelectPlan }: FinalCTAProps) => {
  return (
    <div className="mt-20 text-center animate-slide-up [animation-delay:600ms] opacity-0">
      <div className="bg-card/40 border border-border/50 rounded-lg p-8 max-w-3xl mx-auto backdrop-blur-sm">
        <h2 className="text-2xl font-bold mb-4">Ready to grow your Spotify presence?</h2>
        <p className="text-muted-foreground mb-6">Join thousands of successful artists who are building their audience with Dropify.</p>
        <Button 
          size="lg" 
          className="group"
          onClick={() => onSelectPlan('annual')}
          disabled={isProcessing !== null}
        >
          {isProcessing ? (
            <>
              <Loader2 size={16} className="mr-2 animate-spin" />
              Processing...
            </>
          ) : (
            <>
              Start My FREE Trial
              <ArrowRight size={16} className="ml-2 transition-transform group-hover:translate-x-1" />
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default FinalCTA;
